export default __webpack_public_path__ + "8a0600a46b7ed5e54ea0fa00cbfb188d.pdf";